module.exports = __webpack_public_path__ + "img/download-menu.e13128ce.svg";